import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { usePostAgreementTemplate } from 'services/templates/agreement-template';
import { IContractTemplateForm } from 'services/templates/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { contractTemplateUtil } from 'utils';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const CreateAgreementTemplate = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const createAgreementTemplate = usePostAgreementTemplate();

  const goBackToContractTemplate = () => navigate('/templates-extended');

  const onCreateAgreementTemplate = async (values: IContractTemplateForm) => {
    if (values.sideMenu?.detail) {
      return await createAgreementTemplate.mutateAsync(
        middleware.template.agreement.formToQuery(
          values.sideMenu?.detail.content
        ),
        {
          onSuccess: id => navigate(`/templates-extended/agreement/${id}/form`),
          onError: error => onErrorShowAllErrorsToast(error),
        }
      );
    }
  };

  return (
    <Form.Contract
      tittle={t('contract-template.agreement.title')}
      customBackItem={
        <Button type='button' onlyIcon onClick={goBackToContractTemplate}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <>
          <Button type='submit' variant={BUTTON_VARIANT.submit}>
            <Button.Text text={t(`button.create`)} />
          </Button>
        </>
      }
      initialStatus={contractTemplateUtil.agreement.initialStatus}
      initialValues={contractTemplateUtil.agreement.initialValues()}
      onSubmit={onCreateAgreementTemplate}
    />
  );
};

export default CreateAgreementTemplate;
